<ng-container *ngIf="data">
  <greco-purchase-page
    [communityId]="(data.communityId) || undefined"
    [purchase]="data.purchase"
    [showOptions]="true"
  ></greco-purchase-page>
</ng-container>
